import React, {
  createContext,
  useContext,
  useEffect,
  useMemo,
  useReducer,
} from "react";
import { getAllTranslationsParams } from "../Backend/LanguageRequests";
import { Languages } from "../Constants";
import { LocalStorage } from "../Helpers";
import i18n, { API_NAME } from "../i18n";
import { configReducer, CONFIG_ACTION_CULTURE } from "../Reducer/ConfigReducer";

export const ConfigContext = createContext({});

export const ConfigProvider = ({ children }) => {
  const [ls_culture, set_ls_culture] = LocalStorage("culture", Languages[0].id)

  const [state, dispatch] = useReducer(configReducer, { culture: ls_culture });

  useEffect(() => {
    loadTranslations(state.culture);
  }, [state.culture]);

  const loadTranslations = async (culture) => {
    const respTranslations = await getAllTranslationsParams(culture);
    if (respTranslations.success) {
      const parsedTranslations = respTranslations.data.reduce((acc, item) => {
        if (item.key !== "" && item.value !== "" && item.value !== null) {
          acc[item.key] = item.value;
        }
        return acc;
      }, {});

      i18n.addResources(culture, API_NAME, parsedTranslations);
      i18n.changeLanguage(culture);
      set_ls_culture(culture);
      console.log(
        "%cLanguage:",
        "color: white; background-color: DarkOrchid; padding: 5px",
        culture
      );
    }
  };

  const changeCulture = (culture) => {
    dispatch({
      type: CONFIG_ACTION_CULTURE,
      payload: culture,
    });
  };

  const contextValue = useMemo(
    () => ({
      ...state,
      changeCulture,
    }),
    [state]
  );

  return (
    <ConfigContext.Provider value={contextValue}>
      {children}
    </ConfigContext.Provider>
  );
};

export const useConfigContext = () => {
  return useContext(ConfigContext);
};
